const URLS = {
  /* third party url*/
  IPIFY: "https://api.ipify.org/?format=json",
  IPSTACK_URL: "http://api.ipstack.com/",

  /*base_url*/
  BASE_URL: process.env.VUE_APP_API_URL,

  /* Local Urls*/
  SPLASH: "/master/splash/",
  LOGIN: "/user/login/",
  CARD_HOME: "/card/home/",
  CARD_LIST: "/card/list/",
  CARD_LIST_V2: "/card/list/v2/",
  SHARE_CARD: "/card/share_card/",
  SHARE_TEMPLATE: "/card/share_template/",
  CARD_PREVIEW_CARD_HTML: "/card/preview_card_html/",

  CARD_BOOKMARK_LIST: "/card/bookmark/list/",

  CARD_TEMPLATES: "/card/templates/",
  TEMPLATES: "/templates/",
  LANGUAGES: "/master/languages/",
  BOOKMARK: "/card/bookmark/",
  CANCEL_STRIP_PAYMENT: "card/cancel_stripe_payment",

  SUGGEST_CARD: "/card/suggest/",
  GET_CARD: "/card/get/",
  CREATE_CARD: "/card/create/",
  EDIT_CARD: "/card/edit/",

  CARD_WEDDING_CARD_CATEGORY: "/card/wedding_card_category/",

  MASTER_CONTACT_US: "/master/contact_us/",
  MASTER_FAQ: "/master/faq/",

  FREE_INVITE_PREVIEW: "/card/free_invite_preview_html/"
};
export default URLS;
